import moment from 'moment';
import React, { lazy, useState } from 'react';
import { radiusComplianceColumns, descColumns } from './columnMapping';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const RadiusComplianceAlerts = ({ list, i18n }) => {
  const [openModalDesc, setModalDesc] = useState(false);
  const [ModalDescData, setModalDescData] = useState({
    header: '',
    content: () => {
      return <> </>;
    },
  });

  const typeToAlertKey = {
    radius: 'multipleRadiusAlert',
    accident: 'multipleAccidentAlert',
    dvir: 'multipleDvirAlert',
  };

  const getAlertTranslationKey = (type) => {
    const foundKey = Object.keys(typeToAlertKey).find((key) => type?.toLowerCase().includes(key));
    return typeToAlertKey[foundKey] || 'multipleAlert';
  };

  const generateRows = () => {
    list.map((ele) => {
      if (ele.descriptions?.length > 1) {
        ele.description = (
          <div className="descPopUp" onClick={() => handleDecPopup(ele)}>
            {i18n.t(getAlertTranslationKey(ele.type))}
          </div>
        );
      } else if (ele.descriptions?.length == 1) {
        ele.description = ele.descriptions[0]?.description;
      }
    });
    return list;
  };

  const generateDescRows = (list) => {
    list.map((ele) => {
      let date = new Date(ele.date);
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
      ele.date = moment(date).format('MM/DD/YYYY HH:mm:ss');
    });
    return list;
  };

  const handleDecPopup = (data) => {
    setModalDesc(true);
    setModalDescData({
      content: () => {
        return (
          <div className="descModal">
            <div className="headWrapper">{data.companyName}</div>
            <Table
              type="client"
              defaultSortBy={{ sortBy: 'date', order: 'desc' }}
              title=""
              columns={descColumns}
              data={generateDescRows(data.descriptions)}
              emptyMessage={i18n.t('common.tableEmptyMessage')}
              itemsPerPage={5}
              id="dashBoardAlertsDescriptionPopUp"
              actions={[]}
              i18n={i18n}
            />
          </div>
        );
      },
    });
  };

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'date', order: 'desc' }}
        title=""
        columns={radiusComplianceColumns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        id="dashBoardAlerts"
        noPagination
        actions={[]}
        i18n={i18n}
      />
      <Modal
        open={openModalDesc}
        setOpen={setModalDesc}
        data={ModalDescData}
        deletePopup
        withCloseIcon
        width={'800px'}
        alignItemsLeft
      />
    </>
  );
};

export default RadiusComplianceAlerts;

RadiusComplianceAlerts.defaultProps = {};
